export const theme = {
  colours: {
    black: '#373737',
    white: 'white',
    darkGrey: '#898989',
    midGrey: '#bebebe',
    loadingBackground: '#d5d5d5',
    lightGrey2: '#eaeaea',
    lightGrey1: '#fafafa',
    ttcYellow: '#fcd530',
    // Links
    link: '#623EF9',
    visited: '#551a8b',
    // Accessibility and forms
    focus: '#4fcd90',
    error: '#d0021b',
  },
  general: {
    shadingGrey: 'rgb(235,235,236)',
  },
  skintone: {
    veryFair: 'rgb(253,238,199)',
    fair: 'rgb(234,212,171)',
    rosy: 'rgb(230,170,134)',
    mediumFair: 'rgb(239,187,166)',
    olive: 'rgb(197,143,99)',
    tanned: 'rgb(200,177,123)',
    midLevel: 'rgb(132,87,54)',
    dark: 'rgb(92,51,31)',
  },
  eyecolour: {
    lightBrown: 'rgb(139,11,74)',
    brown: 'rgb(110,74,56)',
    darkBrown: 'rgb(41,1,1)',
    hazel: 'rgb(158,124,79)',
    amber: 'rgb(213,127,55)',
    teal: 'rgb(205,212,219)',
  },
  haircolour: {
    black: 'rgb(0,0,0)',
    darkBrown: 'rgb(41,1,1)',
    mediumBrown: 'rgb(110,74,56)',
    lightBrown: 'rgb(139,11,74)',
    chestnut: 'rgb(132,87,54)',
    hazel: 'rgb(158,124,79)',
    red: 'rgb(255,0,0)',
  },
  breakpoints: {
    sm: 'min-width: 576px',
    md: 'min-width: 768px',
    lg: 'min-width: 992px',
    xl: 'min-width: 1200px',
  },
  maxWidth: '40rem',
  typography: {
    base: 1.6,
    scale: {
      xs: 1.067,
      sm: 1.067,
      md: 1.125,
      lg: 1.125,
    }
  },
  typeface: {
    serif: `'Roboto Slab', serif`,
    sansSerif: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif`,
  },
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2)',
  typeStyles: ( exp ) => {
    return `font-size: ${theme.typography.base * Math.pow( theme.typography.scale.xs, exp )}rem;
    @media ( ${theme.breakpoints.sm} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.sm, exp )}rem;
    }
    @media ( ${theme.breakpoints.md} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.md, exp )}rem;
    }
    @media ( ${theme.breakpoints.lg} ) {
      font-size: ${theme.typography.base * Math.pow( theme.typography.scale.lg, exp )}rem;
    }`
  },
};
